/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SellerCapabilityCspSourceEnum = 'VMC' | 'VCF' | 'IGNORE';

export const SellerCapabilityCspSourceEnum = {

    VMC: 'VMC' as SellerCapabilityCspSourceEnum,

    VCF: 'VCF' as SellerCapabilityCspSourceEnum,

    IGNORE: 'IGNORE' as SellerCapabilityCspSourceEnum
};

